import { render, staticRenderFns } from "./CalendarNavWeek.vue?vue&type=template&id=4fcd87dd"
import script from "./CalendarNavWeek.vue?vue&type=script&lang=js"
export * from "./CalendarNavWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports